'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconCheckbox = require('./IconCheckbox');

Object.keys(_IconCheckbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _IconCheckbox[key];
    }
  });
});